import "./loadingScreen.css";
import { useEffect, useRef, useState } from "react";
import { useProgress } from "@react-three/drei";
import { state } from "../store";
import { useSnapshot } from "valtio";
import { exportedAudioRef } from "../AudioButton/AudioButton";

export default function LoadingScreen() {
  const { progress } = useProgress();
  const { finishedMainLoading, finishedIntro } = useSnapshot(state);
  const mainCanvas = document.getElementsByTagName("canvas");
  const [visibleButton, setVisibleButton] = useState(false);

  const progressRef = useRef();
  const timeoutRef = useRef(); // Store timeout ID

  useEffect(() => {
    if (progressRef && progressRef.current)
      //   progressRef.current.style.transform = `scaleX(${progress}%`
      document.documentElement.style.setProperty(
        "--progress",
        Math.floor(progress)
      );

    if (progress === 100) {
      timeoutRef.current = setTimeout(() => {
        state.finishedMainLoading = true;
        state.entered = true;
        // if (exportedAudioRef.current) {
        //   exportedAudioRef.current.play();
        // }
        if (finishedMainLoading) {
          mainCanvas[0].className = mainCanvas[0].className + " visible";
        }
      }, 1500);
    }

    // Cleanup function to clear timeout
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [progress]);

  return (
    <>
      {!finishedIntro && (
        <div
          // className={`loader-wrapper`}
          className={`loader-wrapper ${
            finishedMainLoading ? "finished-loading" : ""
          }`}
        >
          <div className="main-loader" ref={progressRef}>
            {/* <p>Loading</p> */}
            <svg
              width="100"
              height="100"
              className="circular-progress"
              viewBox="0 0 100 100"
              opacity={visibleButton ? 0 : 1}
            >
              <circle cy={50} cx={50} r={46} className="bg"></circle>
              <circle cy={50} cx={50} r={46} className="fg"></circle>
            </svg>
            {/* <span ref={progressRef} className='progress-loader'></span> */}
          </div>
        </div>
      )}
    </>
  );
}
